<script setup lang="ts">
import { XMarkIcon } from '@heroicons/vue/24/outline'
import { useAuthAdvisorPanel } from '#auth/composables/useAuthAdvisorPanel'

defineProps<{
  dismissible?: boolean
}>()

const emit = defineEmits<{
  (e: 'close'): void
}>()

const { valueProp } = useAuthAdvisorPanel()
</script>

<template>
  <div class="relative flex h-full flex-col overflow-hidden rounded-lg text-white">
    <div
      class="pointer-events-none absolute inset-0 rotate-180 bg-cover bg-center bg-[url(/auth/login-modal-bg.webp)]"
      aria-hidden="true"
    />

    <img
      :src="valueProp.image"
      alt=""
      aria-hidden="true"
      class="pointer-events-none absolute -left-10.5 -bottom-42.5 w-[485px] max-w-none select-none"
    >

    <div class="relative flex flex-1 flex-col p-8">
      <div class="flex items-start justify-between">
        <img
          src="/app/logo-light.svg"
          alt="Forgd"
          class="h-[18px] w-auto"
        >
        <button
          v-if="dismissible"
          type="button"
          class="-mr-1 -mt-1 flex h-8 w-8 items-center justify-center rounded-md text-white/80 transition-colors hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white/60"
          aria-label="Close"
          @click="emit('close')"
        >
          <XMarkIcon class="h-5 w-5" />
        </button>
      </div>

      <div class="mt-6 font-display">
        <h2 class="text-3xl font-normal leading-tight">
          {{ valueProp.title }}
        </h2>
        <ul class="mt-6 space-y-2">
          <li
            v-for="bullet in valueProp.bullets"
            :key="bullet"
            class="flex items-center gap-4"
          >
            <img
              src="/auth/checkmark.svg"
              alt=""
              aria-hidden="true"
              class="w-[18px] shrink-0"
            >
            <span class="text-base">{{ bullet }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
